import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState("idle");

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");

    try {
      const response = await fetch("https://autobotics.co.in/api/contact/send", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (!response.ok) throw new Error("Failed");

      setStatus("success");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (error) {
      setStatus("error");
    }
  };

  return (
    <section id="contact" className="contact section">
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <h2>Ready to Transform Your Ideas?</h2>
        <p>
          Every great innovation starts with a single idea. Share yours with us — and we’ll help you turn it into an intelligent, scalable solution powered by AI, automation, and creativity.
        </p>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row align-items-center">
          {/* Contact Form */}
          <div className="col-lg-5" data-aos="fade-right" data-aos-delay="200">
            <div className="contact-form-card">
              <div className="form-header">
                <div className="header-icon">
                  <i className="bi bi-chat-dots-fill"></i>
                </div>
                <h3>Let's Start a Conversation</h3>
                <p>
                  We’d love to hear from you. Whether you’re exploring automation, planning a new project, or just curious about what AI can do for your business — let’s connect and make it happen.
                </p>
              </div>

              <form onSubmit={handleSubmit} className="php-email-form">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Your Name"
                      value={form.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Email Address"
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <input
                    type="text"
                    name="subject"
                    className="form-control"
                    placeholder="What's this about?"
                    value={form.subject}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-4">
                  <textarea
                    name="message"
                    className="form-control"
                    rows="4"
                    placeholder="Tell us more about your project..."
                    value={form.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <div className="my-3 text-center">
                  {status === "loading" && <div className="loading">Sending...</div>}
                  {status === "error" && (
                    <div className="error-message">Error sending message. Please try again.</div>
                  )}
                  {status === "success" && (
                    <div className="sent-message">Your message has been sent. Thank you!</div>
                  )}
                </div>

                <button type="submit" className="submit-btn">
                  <span>Send Message</span>
                  <i className="bi bi-send-fill"></i>
                </button>
              </form>
            </div>
          </div>

          {/* Contact Info */}
          <div className="col-lg-7" data-aos="fade-left" data-aos-delay="200">
            <div className="contact-info-area">
              <div className="info-header">
                <h3></h3>
                <p></p>
              </div>

              <div className="contact-methods">
                <div className="method-card" data-aos="zoom-in" data-aos-delay="250">
                  <div className="card-icon">
                    <i className="bi bi-envelope-at"></i>
                  </div>
                  <div className="card-content">
                    <h5>Email Us</h5>
                    <p>hello@autobotics.co.in</p>
                    <span className="response-time">Response in 2-4 hours</span>
                  </div>
                </div>

                <div className="method-card" data-aos="zoom-in" data-aos-delay="300">
                  <div className="card-icon">
                    <i className="bi bi-telephone"></i>
                  </div>
                  <div className="card-content">
                    <h5>Call Us</h5>
                    <p>+91 63523 00594 </p>
                    <span className="response-time">Available 9AM - 6PM IST</span>
                  </div>
                </div>

                <div className="method-card" data-aos="zoom-in" data-aos-delay="350">
                  <div className="card-icon">
                    <i className="bi bi-geo-alt"></i>
                  </div>
                  <div className="card-content">
                    <h5>Visit Our Office</h5>
                    <p>236, Aristo , Vadodara, Gujarat India 390021</p>
                    <span className="response-time">Open Monday - Friday</span>
                  </div>
                </div>
              </div>

              <div className="additional-info" data-aos="fade-up" data-aos-delay="400">
                <div className="info-stats">
                  <div className="stat-item">
                    <div className="stat-number">24h</div>
                    <div className="stat-label">Average Response</div>
                  </div>
                  <div className="stat-item">
                    <div className="stat-number">98%</div>
                    <div className="stat-label">Client Satisfaction</div>
                  </div>
                  <div className="stat-item">
                    <div className="stat-number">150+</div>
                    <div className="stat-label">Projects Delivered</div>
                  </div>
                </div>

                <div className="social-connect">
                  <h6>Connect With Us</h6>
                  <div className="social-links">
                    <a href="https://www.linkedin.com/company/autoboticsllp" className="social-link"><i className="bi bi-linkedin"></i></a>
                    <a href="#" className="social-link"><i className="bi bi-twitter-x"></i></a>
                    <a href="#" className="social-link"><i className="bi bi-github"></i></a>
                    <a href="#" className="social-link"><i className="bi bi-discord"></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;